/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builds_Comparison_Changedfiles1Inputs */

const id_builds_comparison_changedfiles1 = /** @type {(inputs: Builds_Comparison_Changedfiles1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`File yang berubah`)
};

const ms_builds_comparison_changedfiles1 = /** @type {(inputs: Builds_Comparison_Changedfiles1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fail yang berubah`)
};

const da_builds_comparison_changedfiles1 = /** @type {(inputs: Builds_Comparison_Changedfiles1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ændrede filer`)
};

const de_builds_comparison_changedfiles1 = /** @type {(inputs: Builds_Comparison_Changedfiles1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geänderte Dateien`)
};

const en_us2_builds_comparison_changedfiles1 = /** @type {(inputs: Builds_Comparison_Changedfiles1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Changed files`)
};

const es_es2_builds_comparison_changedfiles1 = /** @type {(inputs: Builds_Comparison_Changedfiles1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archivos modificados`)
};

const es_mx2_builds_comparison_changedfiles1 = /** @type {(inputs: Builds_Comparison_Changedfiles1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archivos modificados`)
};

const fil_builds_comparison_changedfiles1 = /** @type {(inputs: Builds_Comparison_Changedfiles1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga binagong file`)
};

const fr_builds_comparison_changedfiles1 = /** @type {(inputs: Builds_Comparison_Changedfiles1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fichiers modifiés`)
};

const it_builds_comparison_changedfiles1 = /** @type {(inputs: Builds_Comparison_Changedfiles1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`File modificati`)
};

const hu_builds_comparison_changedfiles1 = /** @type {(inputs: Builds_Comparison_Changedfiles1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Módosított fájlok`)
};

const nl_builds_comparison_changedfiles1 = /** @type {(inputs: Builds_Comparison_Changedfiles1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gewijzigde bestanden`)
};

const no_builds_comparison_changedfiles1 = /** @type {(inputs: Builds_Comparison_Changedfiles1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Endrede filer`)
};

const pl_builds_comparison_changedfiles1 = /** @type {(inputs: Builds_Comparison_Changedfiles1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zmienione pliki`)
};

const pt_br2_builds_comparison_changedfiles1 = /** @type {(inputs: Builds_Comparison_Changedfiles1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arquivos alterados`)
};

const pt_builds_comparison_changedfiles1 = /** @type {(inputs: Builds_Comparison_Changedfiles1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ficheiros alterados`)
};

const ro_builds_comparison_changedfiles1 = /** @type {(inputs: Builds_Comparison_Changedfiles1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fișiere modificate`)
};

const fi_builds_comparison_changedfiles1 = /** @type {(inputs: Builds_Comparison_Changedfiles1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muuttuneet tiedostot`)
};

const sv_builds_comparison_changedfiles1 = /** @type {(inputs: Builds_Comparison_Changedfiles1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ändrade filer`)
};

const vi_builds_comparison_changedfiles1 = /** @type {(inputs: Builds_Comparison_Changedfiles1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tệp đã thay đổi`)
};

const tr_builds_comparison_changedfiles1 = /** @type {(inputs: Builds_Comparison_Changedfiles1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Değişen dosyalar`)
};

const cs_builds_comparison_changedfiles1 = /** @type {(inputs: Builds_Comparison_Changedfiles1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Změněné soubory`)
};

const bg_builds_comparison_changedfiles1 = /** @type {(inputs: Builds_Comparison_Changedfiles1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Променени файлове`)
};

const ru_builds_comparison_changedfiles1 = /** @type {(inputs: Builds_Comparison_Changedfiles1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изменённые файлы`)
};

const uk_builds_comparison_changedfiles1 = /** @type {(inputs: Builds_Comparison_Changedfiles1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Змінені файли`)
};

const ar_builds_comparison_changedfiles1 = /** @type {(inputs: Builds_Comparison_Changedfiles1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الملفات المتغيرة`)
};

const hi_builds_comparison_changedfiles1 = /** @type {(inputs: Builds_Comparison_Changedfiles1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बदली गई फ़ाइलें`)
};

const th_builds_comparison_changedfiles1 = /** @type {(inputs: Builds_Comparison_Changedfiles1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไฟล์ที่เปลี่ยนแปลง`)
};

const ja_builds_comparison_changedfiles1 = /** @type {(inputs: Builds_Comparison_Changedfiles1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`変更されたファイル`)
};

const zh_cn2_builds_comparison_changedfiles1 = /** @type {(inputs: Builds_Comparison_Changedfiles1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已更改文件`)
};

const zh_hant1_builds_comparison_changedfiles1 = /** @type {(inputs: Builds_Comparison_Changedfiles1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已變更檔案`)
};

const ko_builds_comparison_changedfiles1 = /** @type {(inputs: Builds_Comparison_Changedfiles1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`변경된 파일`)
};

/**
* | output |
* | --- |
* | "Changed files" |
*
* @param {Builds_Comparison_Changedfiles1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const builds_comparison_changedfiles1 = /** @type {((inputs?: Builds_Comparison_Changedfiles1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builds_Comparison_Changedfiles1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_builds_comparison_changedfiles1(inputs)
	if (locale === "ms") return ms_builds_comparison_changedfiles1(inputs)
	if (locale === "da") return da_builds_comparison_changedfiles1(inputs)
	if (locale === "de") return de_builds_comparison_changedfiles1(inputs)
	if (locale === "en-US") return en_us2_builds_comparison_changedfiles1(inputs)
	if (locale === "es-ES") return es_es2_builds_comparison_changedfiles1(inputs)
	if (locale === "es-MX") return es_mx2_builds_comparison_changedfiles1(inputs)
	if (locale === "fil") return fil_builds_comparison_changedfiles1(inputs)
	if (locale === "fr") return fr_builds_comparison_changedfiles1(inputs)
	if (locale === "it") return it_builds_comparison_changedfiles1(inputs)
	if (locale === "hu") return hu_builds_comparison_changedfiles1(inputs)
	if (locale === "nl") return nl_builds_comparison_changedfiles1(inputs)
	if (locale === "no") return no_builds_comparison_changedfiles1(inputs)
	if (locale === "pl") return pl_builds_comparison_changedfiles1(inputs)
	if (locale === "pt-BR") return pt_br2_builds_comparison_changedfiles1(inputs)
	if (locale === "pt") return pt_builds_comparison_changedfiles1(inputs)
	if (locale === "ro") return ro_builds_comparison_changedfiles1(inputs)
	if (locale === "fi") return fi_builds_comparison_changedfiles1(inputs)
	if (locale === "sv") return sv_builds_comparison_changedfiles1(inputs)
	if (locale === "vi") return vi_builds_comparison_changedfiles1(inputs)
	if (locale === "tr") return tr_builds_comparison_changedfiles1(inputs)
	if (locale === "cs") return cs_builds_comparison_changedfiles1(inputs)
	if (locale === "bg") return bg_builds_comparison_changedfiles1(inputs)
	if (locale === "ru") return ru_builds_comparison_changedfiles1(inputs)
	if (locale === "uk") return uk_builds_comparison_changedfiles1(inputs)
	if (locale === "ar") return ar_builds_comparison_changedfiles1(inputs)
	if (locale === "hi") return hi_builds_comparison_changedfiles1(inputs)
	if (locale === "th") return th_builds_comparison_changedfiles1(inputs)
	if (locale === "ja") return ja_builds_comparison_changedfiles1(inputs)
	if (locale === "zh-CN") return zh_cn2_builds_comparison_changedfiles1(inputs)
	if (locale === "zh-Hant") return zh_hant1_builds_comparison_changedfiles1(inputs)
	return ko_builds_comparison_changedfiles1(inputs)
});
export { builds_comparison_changedfiles1 as "builds.comparison.changedFiles" }